import Tooltip, { type TooltipSize } from "@/components/common/Tooltip";
import type { FloatingPlacement } from "@/utils/ui/floatingOverlay";

const FormRow: React.FC<FormRowProps> = ({
  header = "",
  fontSize = "text-xs poppins text-black dark:text-gray-200 pb-2",
  hidden = false,
  tooltip,
  children,
  tooltipOptions,
}) => {
  return (
    <div className={`${hidden ? "hidden" : ""} mt-1 relative w-full`}>
      <div className={`${fontSize} flex flex-row pt-2`}>
        <div className="flex w-4/5">{header}</div>
        <div className="flex w-1/5 justify-end">
          {tooltip && (
            <Tooltip
              content={tooltip}
              placement={tooltipOptions?.placement ?? "left"}
              size={tooltipOptions?.size ?? "sm"}
              //triggerClassName="ml-1"
            />
          )}
        </div>
      </div>
      {children}
    </div>
  );
};
export default FormRow;

type TooltipOptions = {
  placement?: FloatingPlacement;
  size?: TooltipSize;
};

type FormRowProps = {
  header?: string;
  content?: React.ReactNode;
  fontSize?: string;
  hidden?: boolean;
  tooltip?: string;
  tooltipOptions?: TooltipOptions;
  children?: React.ReactNode;
};
